/**
 * The logo, in one place.
 *
 * Two artworks ship: a DARK-ink lockup for light backgrounds and a LIGHT-ink
 * lockup for dark ones. Which shows is decided in CSS from
 * `data-theme-group` on <html> (and from `.hb-scope` inside the client
 * workspace), so nothing here has to know about themes and no component has to
 * be told twice. `variant` overrides it for surfaces with a fixed background
 * (an always-dark hero, a white card).
 *
 * The lockup is TALL. Square slots use <BrandMark>, which is the rocket alone —
 * never the lockup squeezed into a square.
 */
const SRC = {
  // The horizontal lockup is true vector, so it goes in as SVG. The vertical
  // lockup and the mark are still raster until their SVGs land (F-34).
  horizontal: {
    'dark-ink': '/brand/hirojet-horizontal-dark-ink.svg',
    'light-ink': '/brand/hirojet-horizontal-light-ink.svg',
  },
  lockup: { 'dark-ink': '/brand/lockup-dark-ink.png', 'light-ink': '/brand/lockup-light-ink.png' },
  mark: { 'dark-ink': '/brand/mark-dark-ink.png', 'light-ink': '/brand/mark-light-ink.png' },
};

const Art = ({ kind, variant = 'auto', className = '', testId, alt = 'HiroJet' }) => {
  if (variant !== 'auto') {
    return <img src={SRC[kind][variant]} alt={alt} className={className}
      data-testid={testId} draggable="false" />;
  }
  return (
    <>
      <img src={SRC[kind]['light-ink']} alt={alt}
        className={`brand-art brand-art--light-ink ${className}`}
        data-testid={testId} draggable="false" />
      <img src={SRC[kind]['dark-ink']} alt="" aria-hidden="true"
        className={`brand-art brand-art--dark-ink ${className}`} draggable="false" />
    </>
  );
};

/** Rocket left, wordmark right. For any wide, short slot — a sidebar, a bar, a nav. */
export const BrandHorizontal = (props) => <Art kind="horizontal" {...props} />;
export const BrandLockup = (props) => <Art kind="lockup" {...props} />;
export const BrandMark = (props) => <Art kind="mark" {...props} />;
